import { render, staticRenderFns } from "./genres-picker.vue?vue&type=template&id=25c2de88&scoped=true&"
import script from "./genres-picker.vue?vue&type=script&lang=js&"
export * from "./genres-picker.vue?vue&type=script&lang=js&"
import style0 from "./genres-picker.vue?vue&type=style&index=0&id=25c2de88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c2de88",
  null
  
)

export default component.exports